// extracted by mini-css-extract-plugin
export default {"root":"vBWYW8y9Sr","content":"slkFNxjyXf"};